import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sugnup__form__inputs" }
const _hoisted_2 = { class: "inputs" }
const _hoisted_3 = { class: "inputs__name" }
const _hoisted_4 = { class: "input-item" }
const _hoisted_5 = { class: "input-item" }
const _hoisted_6 = { class: "inputs" }
const _hoisted_7 = { class: "inputs__email" }
const _hoisted_8 = { class: "input-item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" @ ")
const _hoisted_10 = { class: "input-item" }
const _hoisted_11 = { class: "email-sub" }
const _hoisted_12 = { class: "inputs" }
const _hoisted_13 = { class: "input-item" }
const _hoisted_14 = { class: "inputs" }
const _hoisted_15 = { class: "input-item" }
const _hoisted_16 = { class: "inputs d-col2" }
const _hoisted_17 = { class: "input-item" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "input-item" }
const _hoisted_20 = { class: "inputs" }
const _hoisted_21 = { class: "input-item" }
const _hoisted_22 = { class: "p-dialog-title" }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", { src: "/images/new/signmail.png" }, null, -1)
const _hoisted_24 = { class: "message" }
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = { class: "-royalBlue" }
const _hoisted_27 = { class: "buttons" }
const _hoisted_28 = { class: "guidance" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_InputMask = _resolveComponent("InputMask")
  const _component_CustomConfirmDialog = _resolveComponent("CustomConfirmDialog")
  const _component_Alert = _resolveComponent("Alert")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock(_component_Form, {
    class: "signup__form",
    onSubmit: _ctx.signup
  }, {
    default: _withCtx(({ errors }) => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("label", {
            for: "name",
            class: { '-invalid': errors.familyName || errors.firstName }
          }, _toDisplayString(_ctx.t("name")), 3),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Field, {
                modelValue: _ctx.inputData.familyName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputData.familyName = $event)),
                name: "familyName",
                rules: "required"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps({
                    id: "familyName",
                    type: "text",
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => (field.value = $event)
                  }, field, {
                    "aria-placeholder": _ctx.t('last name'),
                    placeholder: _ctx.t('last name'),
                    class: "half input-field"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "aria-placeholder", "placeholder"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "familyName",
                class: "p-error"
              })
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_Field, {
                modelValue: _ctx.inputData.firstName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputData.firstName = $event)),
                name: "firstName",
                rules: "required"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps({
                    id: "firstName",
                    type: "text",
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => (field.value = $event)
                  }, field, {
                    "aria-placeholder": _ctx.t('first name'),
                    placeholder: _ctx.t('first name'),
                    class: "half input-field"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "aria-placeholder", "placeholder"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "firstName",
                class: "p-error"
              })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("label", {
            for: "emailName",
            class: { '-invalid': errors.emailName || errors.emailProvider }
          }, _toDisplayString(_ctx.t("email")), 3),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_Field, {
                modelValue: _ctx.email.emailName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.email.emailName = $event)),
                name: "emailName",
                rules: "required|emailName"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps({
                    id: "emailName",
                    type: "text",
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => (field.value = $event)
                  }, field, { class: "half input-field" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "emailName",
                class: "p-error"
              })
            ]),
            _hoisted_9,
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_Field, {
                modelValue: _ctx.email.emailProvider,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.email.emailProvider = $event)),
                name: "emailProvider",
                rules: "required|emailProvider"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps({
                    id: "emailProvider",
                    type: "text",
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => (field.value = $event)
                  }, field, {
                    disabled: !_ctx.isSelf,
                    class: "half input-field"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "emailProvider",
                class: "p-error"
              })
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedEmailProvider,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedEmailProvider = $event)),
              options: _ctx.emailProviders,
              optionLabel: "name",
              class: "full input-field"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_Button, {
              type: "button",
              onClick: _ctx.checkEmail,
              class: "check-button input-field",
              disabled: !_ctx.state.isPossibleEmailButton
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("EmailCheck")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_Field, {
              modelValue: _ctx.inputData.password,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.inputData.password = $event)),
              name: "password",
              rules: "password"
            }, {
              default: _withCtx(({ field }) => [
                _createVNode("label", {
                  for: "password",
                  class: { '-invalid': errors.password }
                }, _toDisplayString(_ctx.t("password")), 3),
                _createVNode(_component_InputText, _mergeProps({
                  id: "password",
                  type: "password",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, { class: "full input-field" }), null, 16, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "password",
              class: "p-error"
            })
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_Field, {
              modelValue: _ctx.inputData.passwordConfirm,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.inputData.passwordConfirm = $event)),
              name: "passwordConfirm",
              rules: "password|confirmed:@password"
            }, {
              default: _withCtx(({ field }) => [
                _createVNode("label", {
                  for: "passwordConfirm",
                  class: { '-invalid': errors.passwordConfirm }
                }, _toDisplayString(_ctx.t("passwordConfirm")), 3),
                _createVNode(_component_InputText, _mergeProps({
                  id: "passwordConfirm",
                  type: "password",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, { class: "full input-field" }), null, 16, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "passwordConfirm",
              class: "p-error"
            })
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("label", {
              for: "sex",
              class: { '-invalid': errors.sex }
            }, _toDisplayString(_ctx.t("sex")), 3),
            _createVNode(_component_Field, {
              modelValue: _ctx.inputData.sex,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.inputData.sex = $event)),
              name: "sex",
              rules: "required",
              label: _ctx.t('sex')
            }, {
              default: _withCtx(({ field }) => [
                _createVNode("div", _mergeProps({ class: "inputs__sex" }, field), [
                  _createVNode(_component_Button, {
                    type: "button",
                    class: ["half", _ctx.inputData.sex === _ctx.SEX.M ? 'active' : ''],
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.inputData.sex = _ctx.SEX.M))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("male")), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_Button, {
                    type: "button",
                    class: ["half", _ctx.inputData.sex === _ctx.SEX.F ? 'active' : ''],
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.inputData.sex = _ctx.SEX.F))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("female")), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.isValidFormData)
                    ? (_openBlock(), _createBlock("span", _hoisted_18))
                    : _createCommentVNode("", true)
                ], 16)
              ]),
              _: 1
            }, 8, ["modelValue", "label"])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode(_component_Field, {
              modelValue: _ctx.inputData.birthDate,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.inputData.birthDate = $event)),
              name: "birthDate",
              rules: "required|birthdate",
              label: _ctx.t('birthDate')
            }, {
              default: _withCtx(({ field }) => [
                _createVNode("label", {
                  for: "birthDate",
                  class: { '-invalid': errors.birthDate }
                }, _toDisplayString(_ctx.t("birthDate")), 3),
                _createVNode(_component_InputMask, _mergeProps({
                  id: "birthDate",
                  type: "text",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, {
                  class: "full input-field",
                  mask: "9999/99/99",
                  placeholder: "yyyy/mm/dd",
                  slotChar: "yyyy/mm/dd"
                }), null, 16, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["modelValue", "label"]),
            _createVNode(_component_ErrorMessage, {
              name: "birthDate",
              class: "p-error"
            })
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _createVNode(_component_Field, {
              modelValue: _ctx.inputData.mobilePhone,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.inputData.mobilePhone = $event)),
              name: "mobilePhone",
              label: _ctx.t('Phone number'),
              rules: "required|numeric"
            }, {
              default: _withCtx(({ field }) => [
                _createVNode("label", {
                  for: "mobilePhone",
                  class: { '-invalid': errors.mobilePhone }
                }, _toDisplayString(_ctx.t("Phone number")), 3),
                _createVNode(_component_InputText, _mergeProps({
                  id: "mobilePhone",
                  type: "text",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, { class: "full input-field" }), null, 16, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["modelValue", "label"]),
            _createVNode(_component_ErrorMessage, {
              name: "mobilePhone",
              class: "p-error"
            })
          ])
        ])
      ]),
      _createVNode(_component_CustomConfirmDialog, {
        group: "emailSend",
        isButton: false,
        class: "dialog"
      }, {
        title: _withCtx(() => [
          _createVNode("span", _hoisted_22, [
            _hoisted_23,
            _createVNode("p", null, _toDisplayString(_ctx.t("sent confirming email")), 1)
          ])
        ]),
        message: _withCtx(() => [
          _createVNode("div", _hoisted_24, [
            _createTextVNode(_toDisplayString(_ctx.t("check email", { email: _ctx.inputData.email })) + " ", 1),
            _hoisted_25,
            _createVNode("span", _hoisted_26, _toDisplayString(_ctx.t("activate account")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.t("complete to sign-up")), 1)
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode("button", {
              type: "button",
              class: "p-button btn-resend-email",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onResendEmail && _ctx.onResendEmail(...args)))
            }, _toDisplayString(_ctx.t("resend verification email")), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode("div", _hoisted_28, [
            _createVNode("span", null, _toDisplayString(_ctx.t("didnt receive verification email")), 1),
            _createVNode("ul", null, [
              _createVNode("li", null, "- " + _toDisplayString(_ctx.t("did you not receive verification code via email")), 1),
              _createVNode("li", null, "- " + _toDisplayString(_ctx.t("make sure the correct email address")), 1),
              _createVNode("li", null, "- " + _toDisplayString(_ctx.t("check spam mail box")), 1)
            ])
          ])
        ]),
        _: 1
      }),
      (!!_ctx.alert.content)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            alert: _ctx.alert,
            "onUpdate:alert": _cache[14] || (_cache[14] = ($event: any) => (_ctx.alert = $event)),
            isConfirm: true,
            "onUpdate:clear": _cache[15] || (_cache[15] = ($event: any) => (_ctx.alert.content = ''))
          }, null, 8, ["alert"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}